// import { lazy, Suspense } from 'react'
import { LoadingOutlined } from "@ant-design/icons";
import loadable from "@loadable/component";
import { Spin } from "antd";
import "./index.less"
import { getToken } from "@/utils";
import { Navigate, } from "react-router-dom";

// @ts-ignore
import router from "@/router";
// 通用的过场组件


const LoadingComponent = () => {
  return <div className="spin-loading">

<Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
  </div>;
};

// 过场组件默认采用通用的，若传入了loading，则采用传入的过场组件
export default (Loader: any, isAuth:boolean=false,Loading = LoadingComponent, delay = 20) => {
  const LoadableComponent = loadable(() => {

    const token = getToken()

    
  const auth = () => {
    
    return () => {

      router.navigate("/login", {
        replace: true
      });
    }
  }
    return Promise.all([
      (!token && isAuth)? auth() :Loader(),
      new Promise((resolve) => setTimeout(resolve, delay)),
    ]).then(([moduleExports]) => moduleExports);
  });

  return <LoadableComponent fallback={<Loading />} />;
};
